import { Marker, defineMarkerSvg, defineLocationPopup } from "uitk-react-map";

export class ActivityMarker extends Marker {
  public map: any;
  constructor({ ...props }) {
    super(props);

    this.popup.anchor.innerHTML = definePopup();

    this.popup.setMap(this.map);
    this.marker = this.popup;
    this.marker.getPosition = this.getPosition.bind(this);
    this.marker.icon = defineSvg();
    this.marker.map = this.map;
    this.marker.position = this.position;
  }

  public getPosition() {
    return this.position;
  }
}

const defineSvg = () => {
  return defineMarkerSvg(
    24,
    `<path d="M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"></path>`,
    "0 0 24 24",
    24
  );
};

const definePopup = () => {
  return defineLocationPopup(defineSvg());
};
